import type {GetRecommendationsParams} from '@/api/bffHotel';
import type {
  SearchParams,
  FilterParams,
} from '@/modules/common/context/QueryParams/models';

import {differenceInDays} from 'date-fns';

const RECOMMENDATION_LIMIT = 15;

const notNull = <T>(value: T | null | undefined): T | undefined =>
  value === null || (Array.isArray(value) && value.length === 0)
    ? undefined
    : value;

export const extractGetRecommendationsParams = (
  userId: string,
  searchParams: SearchParams,
  filterParams: FilterParams
): GetRecommendationsParams | null => {
  let {durationMax, durationMin} = searchParams;
  const {airports, dateMax, dateMin, destinationId, travelType, rooms} =
    searchParams;
  const adultsCount = rooms?.adultsCount;
  const childrenAges = rooms?.childrenAges;

  if (!adultsCount || !dateMax || !dateMin) {
    return null;
  }

  const {
    boardTypes,
    categoryMin,
    roomAttributes,
    roomTypes,
    hotelAttributes,
    tourOperators,
    transportations,
  } = filterParams;

  if (durationMin === 0 && durationMax === 0) {
    const duration = differenceInDays(new Date(dateMax), new Date(dateMin));

    if (duration >= 1) {
      durationMin = duration;
      durationMax = duration;
    }
  }

  return {
    limit: RECOMMENDATION_LIMIT,
    adults: adultsCount,
    dateMax,
    dateMin,
    travelType,
    children: notNull(childrenAges),
    airports: notNull(airports),
    categoryMin: notNull(categoryMin),
    boardTypes: notNull(boardTypes),
    destinationId: notNull(destinationId),
    durationMax: notNull(durationMax),
    durationMin: notNull(durationMin),
    roomViews: notNull(roomAttributes),
    hotelAttributes: notNull(hotelAttributes),
    roomTypes: notNull(roomTypes),
    tourOperators: notNull(tourOperators),
    transportations: notNull(transportations),
    userId,
  };
};
